module.exports = __webpack_public_path__ + "officialStatic/img/footBg.8894185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footBg.png
// module id = PxHp
// module chunks = 0